(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_kzk-fahrzeugfinder"] && !Shopify.designMode) return;
  try {
    /** Parses an inline JSON script inside root; no dependency on the shared module's load order. */
  const kzkJson = (root, selector) => {
    try {
      const node = root.querySelector(selector);
      return node ? JSON.parse(node.textContent || 'null') : null;
    } catch {
      return null;
    }
  };
  class KzkVehicleFinder extends HTMLElement {
    #controller = new AbortController();

    connectedCallback() {
      this.product = kzkJson(this, '[data-kzk-product]');
      this.strings = kzkJson(this, '[data-kzk-strings]') || {};
      this.addEventListener('kzk:change', this.#handleChange, { signal: this.#controller.signal });
    }

    disconnectedCallback() {
      this.#controller.abort();
    }

    /**
     * Resolves the variant for an option value index pair.
     * @param {number} vehicleIndex 0-based value index of the vehicle option
     * @param {number} regionIndex 0-based value index of the region option
     */
    #variantFor(vehicleIndex, regionIndex) {
      const product = this.product;
      if (!product) return null;
      const vIdx = product.vehicleOption - 1;
      const rIdx = product.regionOption - 1;
      const vehicleOption = product.options.find((option) => option.position === product.vehicleOption);
      const regionOption = product.options.find((option) => option.position === product.regionOption);
      const vehicleValue = vehicleOption ? vehicleOption.values[vehicleIndex] : undefined;
      const regionValue = regionOption ? regionOption.values[regionIndex] : undefined;
      return (
        product.variants.find((variant) => {
          const okVehicle = vehicleValue === undefined || variant.options[vIdx] === vehicleValue;
          const okRegion = regionValue === undefined || variant.options[rIdx] === regionValue;
          return okVehicle && okRegion;
        }) || null
      );
    }

    /** @param {CustomEvent} event */
    #handleChange = (event) => {
      const value = event.detail && event.detail.value;
      const group = this.querySelector('kzk-pill-group');
      const empty = this.querySelector('[data-kzk-finder-empty]');
      const intro = this.querySelector('[data-kzk-finder-intro]');
      const option = this.querySelector('[data-kzk-finder-option]');
      const price = this.querySelector('[data-kzk-finder-price]');
      if (!group || !empty || !intro || !option || !price) return;

      if (!value) {
        empty.hidden = false;
        intro.hidden = option.hidden = price.hidden = true;
        return;
      }

      const pressed = group.buttons.find((button) => button.getAttribute('aria-pressed') === 'true');
      const index = Number(value) - 1;
      const product = this.product;
      const vehicleOption = product ? product.options.find((o) => o.position === product.vehicleOption) : null;
      const name = vehicleOption ? vehicleOption.values[index] : '';
      const target = this.#variantFor(index, 0);
      const base = this.#variantFor(0, 0);

      empty.hidden = true;
      intro.hidden = false;
      intro.textContent = pressed ? pressed.dataset.intro || '' : '';
      const label = (pressed && pressed.dataset.result) || name;
      option.hidden = !label;
      option.textContent = label || '';

      if (target && base && window.KzkMoney) {
        const format = product.moneyFormat;
        const delta = target.price - base.price;
        const line = delta > 0 ? this.strings.priceLine || '' : this.strings.priceLineBase || '';
        price.textContent = line
          .split('[aufpreis]').join(window.KzkMoney.delta(delta, format))
          .split('[preis]').join(window.KzkMoney.format(target.price, format));
        price.hidden = !line;
      } else {
        price.hidden = true;
      }
    };
  }

  if (!customElements.get('kzk-vehicle-finder')) customElements.define('kzk-vehicle-finder', KzkVehicleFinder);
  } catch(e) { console.error(e); }
})();

})();
